<app-assign-modal-content
    [activeModal]="activeModal"
    [activityData]="activityData"
></app-assign-modal-content>
